import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { legalPageAPI } from '../../services/api';
import useSeo from '../../hooks/useSeo';
import { ArrowLeft } from 'lucide-react';

export default function LegalPage() {
    const { slug } = useParams();
    const [page, setPage] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        legalPageAPI.getBySlug(slug).then(res => {
            setPage(res.data);
        }).catch(() => setPage(null)).finally(() => setLoading(false));
        window.scrollTo(0, 0);
    }, [slug]);

    useSeo(page ? {
        title: `${page.title} | Atölye Kirpi`,
        description: `Atölye Kirpi ${page.title}. Müşteri haklarınız ve alışveriş koşullarımız hakkında bilgi edinin.`,
        canonical: `https://xn--atlyekirpi-fcb.com.tr/sayfa/${slug}`
    } : {});

    if (loading) return <div className="loading"><div className="spinner"></div></div>;
    if (!page) return <div className="legal-page"><div className="legal-container"><h1>Sayfa bulunamadı</h1><Link to="/">Ana Sayfa</Link></div></div>;

    return (
        <div className="legal-page">
            <div className="legal-container">
                <Link to="/" className="legal-back"><ArrowLeft size={16} /> Ana Sayfa</Link>
                <h1>{page.title}</h1>
                <div className="legal-content" dangerouslySetInnerHTML={{ __html: page.content }} />
            </div>
        </div>
    );
}
